/*
 * Cestore Main 
 * 
 * Version 1.0.1
 * 
 */

jQuery(document).ready(function($){
   /*
    * Cookie handling
    */
    window.setCookie = function (key, value, hourExpires) {
        var expires = new Date();
        hourExpires = undefined === hourExpires ? 24 : hourExpires;
        
        expires.setTime(expires.getTime() + (hourExpires * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';
    };
    
    window.getCookie = function (key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    };
    
    window.delCookie = function (key) {
        document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    };

}); // end .ready()

/**
 * 
 * Mobile swipe
 */
(function($) {
  $.fn.bcSwipe = function(settings) {
    var config = { threshold: 50 };
    if (settings) {
      $.extend(config, settings);
    }

    this.each(function() {
      var stillMoving = false;
      var start;

      if ('ontouchstart' in document.documentElement) {
        this.addEventListener('touchstart', onTouchStart, false);
      }

      function onTouchStart(e) {
        if (e.touches.length === 1) {
          start = e.touches[0].pageX;
          stillMoving = true;
          this.addEventListener('touchmove', onTouchMove, false);
        }
      }

      function onTouchMove(e) {
        if (stillMoving) {
          var x = e.touches[0].pageX;
          var difference = start - x;
          if (Math.abs(difference) >= config.threshold) {
            cancelTouch();
            if (difference > 0) {
              $(this).carousel('next');
            }
            else {
              $(this).carousel('prev');
            }
          }
        }
      }

      function cancelTouch() {
        this.removeEventListener('touchmove', onTouchMove);
        start = null;
        stillMoving = false;
      }
    });

    return this;
  };

})(jQuery);